function Adoptable(props) {
    return (
        <div className='adoptable'>
        <div id = 'adopt-details'>
          <p>click my eggs boy</p>
        </div>
        <div id = 'adopt-container'>
          <div className='little-guy'>
            <a href="https://dragcave.net/view/QOw6i"><img src="https://dragcave.net/image/QOw6i.gif" style={{borderWidth: 0}} alt="Dragon Cave: Adopt one today!"/></a>
            <p>Walmartholemew</p>
            </div>
          <div className='little-guy'>
            <a href="https://finaloutpost.net/view/Z1JfN/"><img src="https://finaloutpost.net/s/Z1JfN.png"/></a>
            <p>Yarp</p>
          </div>
        </div>
        <button id='hatchery-btn' onClick={()=>props.handlePages("hatchery")}>Feed more beasts</button>

      </div>
    );
  }

  export default Adoptable;